const getters = {
  token: state => state.user.token,
  accessToken: state => state.user.accessToken,
  accessTokenTimeout: state => state.user.accessTokenTimeout,
  roleList: state => state.user.roleList,
  customerConditionType: state => state.user.customerConditionType,
  accountInfo: state => state.user.accountInfo,
  storesList: state => state.user.storesList,
  manageArea: state => state.user.manageArea,
  programTypeList: state => state.user.programTypeList,
  agreements: state => state.user.agreements,
  currCustomer: state => state.apps.currCustomer,
  currDcpRoles: state => state.apps.currDcpRoles,
  currApps: state => state.apps.currApps,
  theme: state => state.apps.theme
}

export default getters
